// CSS utils
export const cssColorHexToRgbA = (hex: string, alpha = 1) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let c: any;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(
      ',',
    )},${alpha})`;
  }
  throw new Error('Bad Hex');
};

export const getBackgroundImage45DegLines = (
  color1: string,
  color2: string,
) => {
  const gradientColorChangePoint = (
    colorEnd: string,
    colorStart: string,
    point: string,
  ) => {
    return `${colorEnd} ${point}, ${colorStart} ${point}`;
  };

  const colorSwaps = ['25%', '50%', '75%'].map((point, index) => {
    if (index % 2 === 0) {
      return gradientColorChangePoint(color1, color2, point);
    }
    return gradientColorChangePoint(color2, color1, point);
  });

  return `repeating-linear-gradient(45deg, ${color1}, ${colorSwaps.join(
    ', ',
  )}, ${color2})`;
};

type ShadowEdges = 'top' | 'bottom' | 'left' | 'right';

export const getInsetEdgeShadows = ({ edges }: { edges: ShadowEdges[] }) => {
  const conf: {
    offset: number;
    horizontal: ShadowEdges[];
    vertical: ShadowEdges[];
  } = {
    offset: 10,
    horizontal: ['left', 'right'],
    vertical: ['top', 'bottom'],
  };

  // TODO: Support shadow on more then 2 edges
  // const filterEdges = (edges: ShadowEdges[], filterSet: ShadowEdges[]) =>
  //   edges.filter((e) => filterSet.includes(e));
  //
  // const hEdges = filterEdges(edges, settings.horizontal);
  // const vEdges = filterEdges(edges, settings.vertical);
  //
  // const shadowSetCount =
  //   hEdges.length > vEdges.length ? hEdges.length : vEdges.length;

  const getOffset = (edge?: ShadowEdges) => {
    switch (edge) {
      case 'top':
      case 'left':
        return conf.offset;
      case 'bottom':
      case 'right':
        return conf.offset * -1;
      default:
        return 0;
    }
  };

  const getDirectedOffset = (
    edges: ShadowEdges[],
    offsetDirections: ShadowEdges[],
  ) => {
    const edge = edges.find((e) => offsetDirections.includes(e));
    return getOffset(edge);
  };

  const vOffset = getDirectedOffset(edges, conf.vertical);
  const hOffset = getDirectedOffset(edges, conf.horizontal);

  const getShadow = (h: number, v: number, o: number) => {
    return (
      `${h}px ${2 + v}px 1px ${-1 - o}px rgba(0,0,0,0.2) inset,` +
      `${h}px ${1 + v}px 1px ${0 - o}px rgba(0,0,0,0.14) inset,` +
      `${h}px ${1 + v}px 3px ${0 - o}px rgba(0,0,0,0.12) inset`
    );
  };

  return getShadow(hOffset, vOffset, conf.offset);
};
